<template>
  <section
    aria-label="Notifications"
    data-shell="notification-stack"
    class="pointer-events-none fixed z-10000 flex justify-center transition-[top,opacity] duration-200 ease-out motion-reduce:transition-none"
    :class="[anchor ? '-translate-y-full' : 'inset-x-0 bottom-2 lg:bottom-5', { 'opacity-0': overlayOpen }]"
    :style="anchor && { left: `${anchor.left}px`, width: `${anchor.width}px`, top: `${anchor.top - GAP}px` }"
    :inert="overlayOpen">
    <div class="flex w-full flex-col gap-2 px-2 lg:w-[36rem] lg:max-w-[calc(100%-16px)] lg:px-0">
      <TransitionGroup v-bind="stackListTransition">
        <NotificationCard
          v-for="notification in notificationStore.notifications"
          :key="notification.id"
          :type="notification.type"
          :message="notification.message"
          :detail="notification.detail"
          :life="notification.sticky ? undefined : notification.life || DEFAULT_LIFE"
          :actions="actionsFor(notification)"
          :held="overlayOpen"
          @dismiss="notificationStore.dismiss(notification.id)" />
      </TransitionGroup>
      <div :data-shell="BOTTOM_STACK_TARGETS.notifications" class="contents" />
    </div>
  </section>
</template>

<script setup lang="ts">
import NotificationCard from '@dashboard/components/common/NotificationCard.vue'
import { BOTTOM_STACK_TARGETS, stackListTransition, useBottomStack } from '@dashboard/composables/useBottomStack'
import { useNotificationStore } from '@dashboard/stores/notificationStore'
import type { AppNotification, NotificationAction } from '@dashboard/stores/notificationStore'
import { computed } from 'vue'

const DEFAULT_LIFE = 3000
const GAP = 8

const notificationStore = useNotificationStore()
const { barStackBox, overlayOpen } = useBottomStack()

// Sit directly above the page card's bars. Outside the app shell (sign-in,
// onboarding) there are no bars, so the stack falls back to the viewport.
const anchor = computed(() => {
  const box = barStackBox.value
  return box && box.width > 0 ? box : null
})

function actionsFor(notification: AppNotification): NotificationAction[] {
  const action = notification.action
  if (!action) {
    return []
  }
  return [
    {
      label: action.label,
      onClick: () => {
        action.onClick()
        notificationStore.dismiss(notification.id)
      }
    }
  ]
}
</script>
